import Stack from '@mui/material/Stack';
import { Typography } from '../Typography';
import Box from '@mui/material/Box';
import { CreateButton } from '../CreateButton';
import { MouseEventHandler, ReactElement, useRef } from 'react';

interface HeaderProps {
  pageName: string;
  onConfirmAction?: MouseEventHandler<HTMLButtonElement>;
  popover?: (anchorElement: HTMLElement) => ReactElement;
}

export const ListScreensHeader = ({
  pageName,
  onConfirmAction,
  popover,
}: HeaderProps): JSX.Element => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center">
        <Typography variant="h6">{pageName}</Typography>
        {onConfirmAction && (
          <CreateButton ref={buttonRef} onConfirmAction={onConfirmAction} />
        )}
      </Stack>
      {popover && buttonRef.current && popover(buttonRef.current)}
    </Box>
  );
};
